module.exports = __webpack_public_path__ + "img/CBT-logo.981f91ba.svg";